import { types as t } from 'mobx-state-tree';

import { uuid } from '@utils/uuid';

const MultiDropdownOption = t.model('MultiDropdownOption', {
  value: t.string,
  display: t.string,
});

const ApplicationFormQuestionType = t.enumeration('QuestionType', [
  'one_line',
  'multi_line',
  'dropdown',
  'multidropdown',
  'attachment',
]);

const ApplicationFormQuestion = t
  .model('ApplicationFormQuestion', {
    id: t.maybe(t.string),
    order: 9999,
    title: '',
    hidden: false,
    required: false,
    multiple: false,
    type: t.optional(ApplicationFormQuestionType, 'one_line'),
    options: t.maybe(t.array(MultiDropdownOption)),
    error: t.union(t.maybe(t.string), t.boolean),
    value: t.maybe(t.union(t.string, t.frozen(), t.array(t.string))),
  })
  .actions((self) => ({
    afterCreate() {
      if (!self.id) {
        self.id = uuid();
      }
    },
    verify() {
      const req = 'apply_error_required';
      if (self.required) {
        if (!self.value || self.value.length === 0) {
          self.error = req;
          return false;
        }
      }
      return true;
    },
    setValue(value, index = null) {
      if (self.type === 'multidropdown') {
        self.value = Object.keys(value)
          .filter((k) => value[k])
          .map((k) => k);
      } else if (self.multiple) {
        let valueArray = Object.assign([], self.value);
        if (index) {
          valueArray.splice(index, 1, value);
        } else if (value) {
          valueArray.push(value);
        }
        self.value = valueArray;
      } else {
        self.value = value;
      }
      self.error = '';
    },
    setFiles(files) {
      self.value = files;
      self.error = '';
    },
    setError(error) {
      self.error = error;
    },
    clearError() {
      self.error = '';
    },
  }));

const ApplicationFormSection = t.model('ApplicationFormSection', {
  id: t.maybe(t.string),
  questions: t.array(ApplicationFormQuestion),
});

export default t.model('ApplicationForm', {
  sections: t.optional(t.array(ApplicationFormSection), []),
});
